import { Box } from '@mui/material';
import { ConfirmDialog } from '@/components/blocks/ConfirmDialog/ConfirmDialog';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks';
import { JSXFromString } from '@/utils';

interface PrepaidCardHelpModalProps {
    handleClose: () => void;
    isOpen: boolean;
}

export const PrepaidCardHelpModal = (props: PrepaidCardHelpModalProps) => {
    const { t } = usePhrase();

    return (
        <ConfirmDialog
            title={''}
            open={props.isOpen}
            handleClose={props.handleClose}
            data-testid="PrePaidCardHelpModal"
        >
            <Box>{t(WALLET_PHRASES.PRE_PAID_CARDS_HELP_MESSAGE)}</Box>
        </ConfirmDialog>
    );
};
